/* VOOR JOU (23 okt 2026) — rij "voor jou" voor herkende bezoekers + A/B-meting.  Zie ops/voorjou/README.md.

   Herkenning (versie 1):
     c = pseudoniem sleuteltje van de ingelogde klant (sections/vj-id.liquid, HMAC; geen klantnummer of e-mail)
     w = eerste 8 tekens van het verlanglijst-id (localStorage wl:1)
   De server (vj.fragrance-gems.nl) geeft alleen product-handles en een testgroep-label terug:
     a = 't' (test: rij tonen), 'c' (controle: niets tonen), '-' (niet herkend / geen lijst).
   De rij zelf komt server-side uit de thema-sectie vj_row (Section Rendering API), dus precies dezelfde kaart als elders.
   Meldt alleen de testarm: i = rij gezien, k = klik, a = in mandje gelegd na een klik (sendBeacon, geen persoonsgegevens). */
(function () {
  'use strict';
  var V = window.VJ;
  if (!V || V.started) return;
  V.started = 1;
  var D = document;

  function ls(k) { try { return window.localStorage.getItem(k); } catch (e) { return null; } }
  function lw(k, v) { try { window.localStorage.setItem(k, v); } catch (e) { /* privévenster */ } }
  function ss(k) { try { return window.sessionStorage.getItem(k); } catch (e) { return null; } }
  function sw(k, v) { try { window.sessionStorage.setItem(k, v); } catch (e) { /* */ } }
  function jp(s) { try { return JSON.parse(s); } catch (e) { return null; } }

  /* ---------- sleutels ---------- */
  function wKey() {
    var t = ls('vj:test');                       // proefsleutel voor de visuele controle (alleen vjtest01 / vjtest0c bestaan)
    if (t && /^vjtest0[1c]$/.test(t)) return t;
    var o = jp(ls('wl:1'));
    var id = o && o.id;
    return typeof id === 'string' && /^[A-Za-z0-9_-]{20,44}$/.test(id) ? id.slice(0, 8) : null;
  }
  function cKey(cb) {
    if (!V.li) return cb(null);
    var c = jp(ss('vj:c'));
    if (c && c.k && Date.now() - c.t < 6 * 3600e3) return cb(c.k);
    fetch(V.root + '?section_id=vj-id', { credentials: 'same-origin' }).then(function (r) { return r.text(); }).then(function (txt) {
      var m = /data-vj-id[^>]*>([^<]+)</.exec(txt || '');
      var j = m && jp(m[1]);
      var k = j && /^[0-9a-f]{32}$/.test(j.k || '') ? j.k : null;
      if (k) sw('vj:c', JSON.stringify({ k: k, t: Date.now() }));
      cb(k);
    }).catch(function () { cb(null); });
  }

  /* ---------- melden (alleen testarm) ---------- */
  var KEYS = { c: null, w: null };
  function ev(e, h) {
    var body = JSON.stringify({ e: e, c: KEYS.c, w: KEYS.w, pt: V.pt, h: h || null });
    try { if (navigator.sendBeacon(V.api + '/v1/e', new Blob([body], { type: 'text/plain;charset=UTF-8' }))) return; } catch (x) { /* */ }
    try { fetch(V.api + '/v1/e', { method: 'POST', body: body, keepalive: true, headers: { 'Content-Type': 'text/plain;charset=UTF-8' } }); } catch (y) { /* */ }
  }

  /* ---------- plaats op de pagina ---------- */
  function main() { return D.getElementById('MainContent') || D.querySelector('main'); }
  function secs() { var m = main(); return m ? Array.prototype.filter.call(m.children, function (x) { return x.classList && x.classList.contains('shopify-section'); }) : []; }
  function anchor() {
    var s = secs(), i;
    if (V.pt === 'home') {
      /* sinds 23 okt (eigenaar): op de plek van de Mykonos-sectie, direct onder de reviewcarrousel */
      for (i = 0; i < s.length; i++) if (/__1779664674d6292eb8$/.test(s[i].id)) return { el: s[i], pos: 'afterend' };
      for (i = 0; i < s.length; i++) if (/new_arrivals/.test(s[i].id)) return { el: s[i], pos: 'beforebegin' };
      for (i = 0; i < s.length; i++) if (/highlights/.test(s[i].id)) return { el: s[i], pos: 'afterend' };
      return s[3] ? { el: s[3], pos: 'beforebegin' } : null;
    }
    if (V.pt === 'product') {
      for (i = 0; i < s.length; i++) if (/__main$/.test(s[i].id)) return { el: s[i], pos: 'afterend' };
      return null;
    }
    /* collectiepagina's: uit sinds 23 okt (eigenaar: hoort niet boven een merkcollectie) */
    return null;
  }

  /* Reserveert ruimte voor wie in de testgroep zit (van een eerder bezoek bekend), zodat de pagina niet verspringt.
     Controle en onbekenden krijgen nooit een lege plek. */
  var slot = null;
  function makeSlot() {
    if (slot) return slot;
    var a = anchor();
    if (!a) return null;
    slot = D.createElement('div');
    slot.className = 'vj-slot';
    slot.setAttribute('data-vj-slot', '');
    var h = window.innerWidth < 750 ? 282 : 300;   // gemeten: compacte rij op telefoon en desktop
    slot.style.cssText = 'overflow:hidden;min-height:' + h + 'px;';
    a.el.insertAdjacentElement(a.pos, slot);
    return slot;
  }
  function dropSlot() {
    if (!slot) return;
    var s = slot; slot = null;
    s.style.transition = 'min-height .25s ease, opacity .25s ease';
    s.style.minHeight = '0px'; s.style.opacity = '0';
    setTimeout(function () { if (s.parentNode) s.parentNode.removeChild(s); }, 300);
  }

  function initRow(root) {
    var track = root.querySelector('.fg-related__track'), nav = root.querySelector('.fg-related__nav');
    if (!track || !nav) return;
    var prev = nav.querySelector('[data-dir="-1"]'), next = nav.querySelector('[data-dir="1"]');
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches, ticking = false;
    function update() {
      var max = track.scrollWidth - track.clientWidth;
      nav.hidden = max <= 2; prev.disabled = track.scrollLeft <= 2; next.disabled = track.scrollLeft >= max - 2;
    }
    function step(dir) {
      var item = track.querySelector('.fg-related__item'), gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      var width = item ? item.getBoundingClientRect().width + gap : track.clientWidth;
      var per = Math.max(1, Math.floor((track.clientWidth + gap) / width));
      track.scrollBy({ left: dir * width * per, behavior: reduce ? 'auto' : 'smooth' });
    }
    prev.addEventListener('click', function () { step(-1); });
    next.addEventListener('click', function () { step(1); });
    track.addEventListener('scroll', function () { if (ticking) return; ticking = true; requestAnimationFrame(function () { update(); ticking = false; }); }, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  var seen = false;
  function watch(root) {
    if (!('IntersectionObserver' in window)) { ev('i'); return; }
    var io = new IntersectionObserver(function (en) {
      if (seen) return;
      for (var i = 0; i < en.length; i++) if (en[i].isIntersecting && en[i].intersectionRatio >= 0.4) { seen = true; ev('i'); io.disconnect(); return; }
    }, { threshold: [0.4] });
    io.observe(root);
    root.addEventListener('click', function (e) {
      var a = e.target && e.target.closest ? e.target.closest('a[data-vj-h]') : null;
      if (!a) return;
      var h = a.getAttribute('data-vj-h');
      ev('k', h);
      var ck = jp(ss('vj:ck')) || { h: [], t: 0 };
      if (ck.h.indexOf(h) < 0) ck.h.push(h);
      ck.t = Date.now();
      sw('vj:ck', JSON.stringify(ck));
      try { var u = new URL(a.href, location.href); u.searchParams.set('vj', '1'); a.href = u.toString(); } catch (x) { /* */ }
    }, true);
  }

  function show(handles) {
    var list = handles.filter(function (h) { return h !== V.h; }).slice(0, V.pt === 'collection' ? 8 : 10);
    if (list.length < 3) { dropSlot(); return; }
    // Sectiegroepen krijgen een voorvoegsel (sections--<nummer>__vj_row): lees het uit de lege wikkel die Shopify op elke pagina zet.
    var wrap = D.querySelector('[id^="shopify-section-sections--"][id$="__vj_row"]');
    if (!wrap) { dropSlot(); return; }
    var url = V.root + 'search?q=' + encodeURIComponent('vj:' + list.join(',')) + '&section_id=' + encodeURIComponent(wrap.id.replace('shopify-section-', ''));
    fetch(url, { credentials: 'same-origin' }).then(function (r) { return r.ok ? r.text() : ''; }).then(function (html) {
      var t = D.createElement('template'); t.innerHTML = html || '';
      var row = t.content.querySelector('[data-vj-row]');
      if (!row || Number(row.getAttribute('data-count')) < 3) { dropSlot(); return; }
      if (V.pt === 'collection') row.classList.add('vj-row--compact');
      var a = anchor();
      if (!a) { dropSlot(); return; }
      if (slot) { slot.parentNode.replaceChild(row, slot); slot = null; } else { a.el.insertAdjacentElement(a.pos, row); }
      initRow(row);
      watch(row);
    }).catch(function () { dropSlot(); });
  }

  /* ---------- mandje na een klik (PerformanceObserver ziet /cart/add, ook als het thema zijn eigen fetch gebruikt) ---------- */
  function watchCart() {
    if (V.pt !== 'product' || !window.PerformanceObserver) return;
    var ck = jp(ss('vj:ck'));
    if (!ck || !ck.h || ck.h.indexOf(V.h) < 0 || Date.now() - ck.t > 4 * 3600e3) return;
    try {
      new PerformanceObserver(function (list) {
        list.getEntries().forEach(function (en) {
          if (!/\/cart\/add(\.js)?(\?|$)/.test(en.name) || en.responseStatus >= 400 || ss('vj:a:' + V.h)) return;
          sw('vj:a:' + V.h, '1');
          ev('a', V.h);
        });
      }).observe({ type: 'resource', buffered: false });
    } catch (e) { /* oudere browser */ }
  }

  /* ---------- start ---------- */
  function start() {
    var cached = ls('vj:a') === 't';
    cKey(function (c) {
      KEYS.c = c; KEYS.w = wKey();
      if (!KEYS.c && !KEYS.w) return;
      if (cached && V.pt === 'collection') makeSlot();
      var ck = 'vj:r:' + (KEYS.c || '') + (KEYS.w || '');
      var hit = jp(ss(ck));
      function apply(r) {
        if (!r || !r.on) { lw('vj:a', 'x'); dropSlot(); return; }
        lw('vj:a', r.a === 't' ? 't' : 'x');
        if (r.a === 't' && r.h && r.h.length) { watchCart(); show(r.h); } else dropSlot();
      }
      if (hit && Date.now() - hit.t < 10 * 60e3) return apply(hit.r);
      var q = '?pt=' + encodeURIComponent(V.pt) + (KEYS.c ? '&c=' + KEYS.c : '') + (KEYS.w ? '&w=' + KEYS.w : '');
      fetch(V.api + '/v1/r' + q, { credentials: 'omit' }).then(function (r) { return r.ok ? r.json() : null; }).then(function (r) {
        if (r) sw(ck, JSON.stringify({ t: Date.now(), r: r }));
        apply(r);
      }).catch(function () { dropSlot(); });
    });
  }
  if (D.readyState === 'loading') D.addEventListener('DOMContentLoaded', start); else start();
})();
